import React from 'react';
import { useTranslation } from 'localization';
import './StickyUnsavedBarMolecule.scss';

export interface StickyUnsavedBarMoleculeProps {
  isDirty: boolean;
  saving?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  className?: string;
}

const StickyUnsavedBarMolecule: React.FC<StickyUnsavedBarMoleculeProps> = ({
  isDirty,
  saving = false,
  onSave,
  onDiscard,
  className = '',
}) => {
  const { t } = useTranslation();

  if (!isDirty) return null;

  const classes = ['marketplace-sticky-unsaved-bar', className].filter(Boolean).join(' ');

  return (
    <div className={classes} role="status" aria-live="polite">
      <span className="marketplace-sticky-unsaved-bar__message">
        <i className="pi pi-exclamation-triangle marketplace-sticky-unsaved-bar__message-icon" aria-hidden="true" />
        {t('marketplace.publishers.manage.unsavedMessage')}
      </span>
      <div className="marketplace-sticky-unsaved-bar__actions">
        <button
          type="button"
          className="marketplace-sticky-unsaved-bar__discard"
          onClick={onDiscard}
          disabled={saving}
        >
          {t('marketplace.publishers.manage.discard')}
        </button>
        <button
          type="button"
          className="marketplace-sticky-unsaved-bar__save"
          onClick={onSave}
          disabled={saving}
        >
          {saving ? (
            <>
              <span className="marketplace-marketplace__spinner marketplace-sticky-unsaved-bar__spinner" />
              {t('marketplace.publishers.manage.saving')}
            </>
          ) : (
            t('marketplace.publishers.manage.save')
          )}
        </button>
      </div>
    </div>
  );
};

StickyUnsavedBarMolecule.displayName = 'StickyUnsavedBarMolecule';

export default StickyUnsavedBarMolecule;
